import { useUserProfileInfo } from '@/entities/user';
import { useSessionStore } from '@/entities/session';
import { useMemo } from 'react';
import {
  DEFAULT_USER_FIRST_NAME,
  DEFAULT_USER_LAST_NAME,
} from '@/shared/config';

export const useExtractUserName = () => {
  const { session } = useSessionStore();
  const { userProfileInfoMap, isUserProfileInfoLoading, userProfileInfoError } =
    useUserProfileInfo();

  const isCorporate =
    session?.additional?.isCorporate && session?.additional?.isVerified;

  const userFullName = useMemo(() => {
    const firstName = userProfileInfoMap?.firstName?.trim();
    const lastName = userProfileInfoMap?.lastName?.trim();
    const companyName = userProfileInfoMap?.companyName?.trim();

    if (isCorporate && companyName) {
      return `${companyName}`;
    }

    if (!firstName && !lastName) {
      return `${DEFAULT_USER_FIRST_NAME} ${DEFAULT_USER_LAST_NAME}`;
    }

    return [firstName, lastName].filter(Boolean).join(' ');
  }, [userProfileInfoMap, isCorporate]);

  return {
    userFullName,
    isUserProfileInfoLoading,
    userProfileInfoError,
  };
};
